import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'

import { QUERY_KEY } from '~/app/features/Gallery/queries/queryFavorites'
import { useFeatureGate } from '~/app/features/Gallery/hooks/useFeatureGate'
import { FEATURE_GATES } from 'shared/featureGates/constants'
import { FAVORITE_CHANGED_EVENT } from '~/app/constants'

export const useFavoriteChangedListener = () => {
  const queryClient = useQueryClient()
  const isNewQVEnabled = useFeatureGate(FEATURE_GATES.GALLERY_QUICK_VIEW_MODAL_ENABLED)

  useEffect(() => {
    if (!isNewQVEnabled) return

    const handleFavoriteChanged = () => {
      queryClient.cancelQueries({ queryKey: [QUERY_KEY] })
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] })
    }

    window.addEventListener(FAVORITE_CHANGED_EVENT, handleFavoriteChanged)

    return () => {
      window.removeEventListener(FAVORITE_CHANGED_EVENT, handleFavoriteChanged)
    }
  }, [queryClient, isNewQVEnabled])
}
